module.exports = __webpack_public_path__ + "img/turkey-chili-in-a-crock-pot.798de346.jpg";